<div
    *ngIf="visible"
    id="back-to-app-bar"
    class="back-to-app-bar"
    role="navigation"
>
    <button
        *ngIf="canGoBack"
        id="back-to-app-button"
        type="button"
        class="back-to-app-bar__back"
        (click)="backToApp()"
    >
        <lucide-icon
            class="back-to-app-bar__icon"
            name="arrow-left"
            [size]="20"
        ></lucide-icon>
        <span>{{ 'layout.back-to-app-bar.back-to-app' | translate }}</span>
    </button>

    <a
        *ngIf="showHomeLink"
        id="all-modules-button"
        class="back-to-app-bar__home"
        routerLink="/portal/menu"
    >
        <lucide-icon name="layout-grid" [size]="18"></lucide-icon>
        <span>{{ 'layout.back-to-app-bar.all-modules' | translate }}</span>
    </a>
</div>
